var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25c9.803 0 17.75 7.947 17.75 17.75S33.803 41.75 24 41.75 6.25 33.803 6.25 24 14.197 6.25 24 6.25zm-1.762 9.249l.321 11.967h3.301l.334-11.967h-3.956zm1.978 18.21c1.397 0 2.25-.803 2.25-2.101 0-1.31-.853-2.114-2.25-2.114-1.385 0-2.25.803-2.25 2.114 0 1.298.865 2.101 2.25 2.101z",
    id: "warning-filled_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#f5af34",
    xlinkHref: "#warning-filled_svg__a",
    transform: "translate(-6 -6)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI0IDYuMjVjOS44MDMgMCAxNy43NSA3Ljk0NyAxNy43NSAxNy43NVMzMy44MDMgNDEuNzUgMjQgNDEuNzUgNi4yNSAzMy44MDMgNi4yNSAyNCAxNC4xOTcgNi4yNSAyNCA2LjI1em0tMS43NjIgOS4yNDlsLjMyMSAxMS45NjdoMy4zMDFsLjMzNC0xMS45NjdoLTMuOTU2em0xLjk3OCAxOC4yMWMxLjM5NyAwIDIuMjUtLjgwMyAyLjI1LTIuMTAxIDAtMS4zMS0uODUzLTIuMTE0LTIuMjUtMi4xMTQtMS4zODUgMC0yLjI1LjgwMy0yLjI1IDIuMTE0IDAgMS4yOTguODY1IDIuMTAxIDIuMjUgMi4xMDF6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiNmNWFmMzQiIHhsaW5rOmhyZWY9IiNhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNiAtNikiLz48L3N2Zz4=";
export { SvgWarningFilled as ReactComponent };